export const THREAD_ID = ['threadId'];
export const CHANNEL = ['channel'];
export const MESSAGE = ['message'];
export const ALLOW_RETRY = ['allowRetry'];